<template>
  <div id="app" class="app" :class="modifiers">
    <transition
      name="screen-slide"
      @after-enter="emitScreenEnter"
    >
      <router-view />
    </transition>
    <TheHeader class="app__header" />
    <TheFooter class="app__footer" />
    <BaseOverlay
      v-if="!isInteractionStarted"
      v-bind="overlay"
      class="app__overlay"
      @click="startInteraction"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import TheHeader from '@/components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import BaseOverlay from '@/components/BaseOverlay.vue';

import CONSTANTS from '@/helpers/constants';

const {
  STEP_START,
  SCREEN_READY,
} = CONSTANTS;

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    BaseOverlay,
  },
  data() {
    return {
      isInteractionStarted: false,
    };
  },
  computed: {
    ...mapState([
      'isBackMove',
    ]),
    modifiers() {
      return {
        app_back_move: this.isBackMove,
      };
    },
    overlay() {
      return {
        icon: 'point',
        text: this.$t('texts.tapScreen'),
      };
    },
  },
  mounted() {
    this.initActions();
  },
  methods: {
    ...mapActions([
      'clearSession',
    ]),
    startInteraction() {
      this.isInteractionStarted = true;
      this.$robot.interactionService.start();
      this.sayGreeting();
    },
    onInteractionStop() {
      this.isInteractionStarted = false;
      this.clearSession();
      this.goToHomeScreen();
    },
    goToHomeScreen() {
      const { home } = this.$router.options.paths;
      if (this.$route.path !== home) {
        this.$router.push(home);
      }
    },
    sayGreeting() {
      this.$robot.dialogService.setCase(STEP_START, true, true);
      this.$robot.dialogService.sayReplicByName(STEP_START, true);
    },
    emitScreenEnter(el) {
      this.$root.$emit(SCREEN_READY, el);
    },
    emitActions(actions) {
      actions.forEach((action) => this.$root.$emit(action));
    },
    initActions() {
      const robotActions = [
        this.$robot.dialogService.onAction(this.emitActions),
        this.$robot.interactionService.onStop(this.onInteractionStop),
        this.$robot.interactionService.onStart(this.startInteraction),
      ];

      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
</script>

<style lang="stylus">
@import '~@/assets/stylus/fonts'
@import '~@/assets/stylus/normalize'
@import '~@/assets/stylus/keyframes'
@import '~@/assets/stylus/blocks'

.app
  position relative
  display block
  width 100%
  height 100%
  font-family 'Fira Sans', system-ui, sans-serif
  font-size calc(1vw + 1vh)
  font-weight 400
  line-height 1
  color $c_text
  overflow hidden

  &__overlay
    fix top left right bottom
    z-index 1000

  &__header
    fix top left right
    height $header_height
    pointer-events none
    z-index 3

  &__footer
    fix bottom left right
    height $footer_height
    z-index 3
</style>
